import { Dispatch, SetStateAction, useEffect } from "react"
import { FormControl, FormHelperText, TextField } from "@mui/material"
import { TestResultForm, TestResultFormErrors } from "../../types"

type PHField = {
  formData: TestResultForm,
  setFormData: Dispatch<SetStateAction<TestResultForm>>,
  formErrors: TestResultFormErrors,
  setFormErrors: Dispatch<SetStateAction<TestResultFormErrors>>,
}

const PHField = (props: PHField) => {
  const { formData, setFormData, formErrors, setFormErrors } = props

  const handleChange = (value: string) => {
    const nextForm = structuredClone(formData)

    nextForm.pH = value || null

    setFormData(nextForm)
  }

  useEffect(() => {
    const nextErrors = structuredClone(formErrors)

    const isValidNumber = Number.isFinite(Number(formData.pH))
    const hasError = Boolean(formData.pH) && !isValidNumber

    nextErrors.pH = hasError

    setFormErrors(nextErrors)
  }, [formData.pH])

  const label = 'pH'
  const value = formData.pH ?? ''
  const placeholder = 'Optional'
  const hasError = formErrors.pH

  return (
    <FormControl fullWidth size="small">
      <TextField
        size="small"
        label={label}
        onChange={(event) => handleChange(event.target.value)}
        value={value}
        placeholder={placeholder}
        error={hasError}
      />
      {
        hasError && (
          <FormHelperText error>
            pH must be a number
          </FormHelperText>
        )
      }
    </FormControl>
  )
}

export default PHField
